// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1n-b4","productName":"Table_productName__3HQgl"};